/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Dvc_Search_Type_UnavailableInputs */

const en_task_dvc_search_type_unavailable = /** @type {(inputs: Task_Dvc_Search_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lookup unavailable for cases that occurred more than 6 months ago`)
};

const pt_br2_task_dvc_search_type_unavailable = /** @type {(inputs: Task_Dvc_Search_Type_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta indisponível para casos ocorridos há mais de 6 meses`)
};

/**
* | output |
* | --- |
* | "Lookup unavailable for cases that occurred more than 6 months ago" |
*
* @param {Task_Dvc_Search_Type_UnavailableInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_dvc_search_type_unavailable = /** @type {((inputs?: Task_Dvc_Search_Type_UnavailableInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Dvc_Search_Type_UnavailableInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_dvc_search_type_unavailable(inputs)
	return pt_br2_task_dvc_search_type_unavailable(inputs)
});